// FailureRateTile.js — fraction of calls in the window classified as failures.
// v1 failure rule: outcome starts with "Call ended before any response" —
// the unambiguous case where the voice agent saved a record but produced no
// progress_log. Other failure modes (carrier no-answer, busy, STIR-B reject)
// aren't yet routed into call_history, so they aren't counted here.

import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useFailureRateSeries } from '../../../hooks/useAdminMetrics';

const FailureRateTile = ({ days = 7 }) => {
  const { rate, failed, total, loading, error } = useFailureRateSeries(days);

  if (error) {
    return (
      <Card><CardContent>
        <Typography color="error">Failure rate unavailable: {error.message}</Typography>
      </CardContent></Card>
    );
  }

  const pct = (rate * 100).toFixed(1);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>Failure Rate ({days}d)</Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography variant="h3">{loading ? '…' : `${pct}%`}</Typography>
          <Typography variant="caption" color="text.secondary">
            {loading ? '' : `${failed} of ${total} calls`}
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          v1 definition: calls where the voice agent connected but produced no contact response.
          Carrier-side failures (no-answer, busy, STIR-B reject) aren't currently routed into
          call_history and aren't counted here.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FailureRateTile;
